import { PagesContainer } from '@/modules/Pages/containers/PagesContainer';

export const Pages = (): JSX.Element => <PagesContainer />;

export default Pages;
